import { render, staticRenderFns } from "./CarefulWishApp.vue?vue&type=template&id=e8d754e6&"
import script from "./CarefulWishApp.vue?vue&type=script&lang=js&"
export * from "./CarefulWishApp.vue?vue&type=script&lang=js&"
import style0 from "./CarefulWishApp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports